var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapsule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32 1.32A4.5 4.5 0 0 1 14.68 7.68L7.68 14.68A4.5 4.5 0 0 1 1.32 8.32L8.32 1.32ZM9.26 2.26L2.26 9.26A3.17 3.17 0 0 0 6.74 13.74L13.74 6.74A3.17 3.17 0 0 0 9.26 2.26ZM6.23 5.29L10.71 9.77A0.67 0.67 0 0 1 9.77 10.71L5.29 6.23A0.67 0.67 0 0 1 6.23 5.29Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsule);
export default __webpack_public_path__ + "static/media/capsule.a3aeb3a2e75e0ba65dbe0c425eb4d091.svg";
export { ForwardRef as ReactComponent };